import {Component, OnInit} from '@angular/core';
import {Question} from '../../../../models/question.model';
import {Answer} from '../../../../models/answer.model';
import {StandardQuestionModel} from '../../../../models/standard-question.model';
import {UserService} from '../../../../services/user.service';
import {TestingService} from '../../../../services/testing.service';
import {Router} from '@angular/router';
import {SidebarService} from '../../../../services/side-bar.service';
import {TaskBarService} from '../../../../services/task-bar.service';
import {HeaderService} from '../../../../services/header.service';
import {AnsweredQuestions} from '../../../../models/answered-questions.model';
import {QuestionWithAnswer} from '../../../../models/question-with-answer.model';
import {TestingProcessService} from './testing-process.service';
import {NotificationsService} from '../../../../services/notifications.service';

@Component({
  selector: 'app-testing-action',
  templateUrl: './testing-action.component.html',
  styleUrls: ['./testing-action.component.css']
})
export class TestingActionComponent implements OnInit {
  successMsg = false;
  noRightMsg = false;
  leaveTesting = false;
  errorGetList = false;
  selectedAllAnswers = false;
  buttonLabel: string;
  answersDone = false;
  answeredQuestions: Map<Question, Answer> = new Map();
  qList: any;
  questionsList: StandardQuestionModel[];
  responsedQuestions: any;
  alreadyAnsweredError = false;

  constructor(private userService: UserService,
              private router: Router,
              private notificationsService: NotificationsService,
              private testingProcessService: TestingProcessService,
              private taskBarService: TaskBarService) {
  }

  ngOnInit() {
    this.taskBarService.closeTaskBar();
    this.buttonLabel = 'CHECK_ANSWERS';

    this.testingProcessService.getQuestionsAPI().subscribe(
      (response) => {
        if (response.status === 200) {
          console.log(1111, response)
          this.qList = response.body;
        }
        if (response.status === 204) {
          this.errorGetList = true;
          this.answersDone = true;
          this.selectedAllAnswers = true;
          this.testingProcessService.setAnswersDone(true);
          this.testingProcessService.setSelectedAllAnswers(true);
          this.testingProcessService.setButtonLabel('Continue');
        }
      }, () => {
        if (this.questionsList == null) {
          this.errorGetList = true;
          this.answersDone = true;
          this.selectedAllAnswers = true;
          this.leaveTesting = true;
          this.testingProcessService.setAnswersDone(true);
          this.testingProcessService.setSelectedAllAnswers(true);
          this.testingProcessService.leaveTesting = true;
        }
      }, () => {
        this.testingProcessService.setQuestions(this.qList);
        this.questionsList = this.testingProcessService.getQuestions();
      }
    );

  }


  selectAnswer(question, answer) {
    this.answeredQuestions.set(question, answer);
    if (this.answeredQuestions.size === this.questionsList.length) {
      this.selectedAllAnswers = true;
    }
    this.testingProcessService.addToAnsweredQuestions(question, answer);
  }

  checkAnswers() {
    this.testingProcessService.successMsg = false;
    this.noRightMsg = false;
    const answers = new AnsweredQuestions;
    this.answeredQuestions.forEach((value: Answer, key: Question) => {
      answers.addQuestionWithAnswer(new QuestionWithAnswer(value, key));
    });

    this.userService.checkAnswersStep(this.testingProcessService.standard.id, answers).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.notificationsService.getNearNotificationFromAPI();
          this.testingProcessService.successMsg = true;
          this.noRightMsg = false;
          this.goToExNotifList();
        }
      }, (error) => {
        if (error.status === 400) {
          this.testingProcessService.successMsg = false;
          this.noRightMsg = true;
        }
      },
    );
  }

  goToExNotifList() {
    if (this.router.url.includes('ex-notification-familiarize-action/')) {
      this.router.navigate(['/ex-notifications']);
    }
  }

  isSelectedAndRight(question, answer) {
    for (const respQ of this.responsedQuestions.answeredQuestion) {
      if (this.answeredQuestions.has(question) && respQ.questionText === question.questionText
        && respQ.rightAnswer.answerText === answer.answerText) {
        return true;
      }
    }
    return false;
  }

  isSelectedAndWrong(question, answer) {
    for (const respQ of this.responsedQuestions.failedQuestions) {
      if (this.answeredQuestions.has(question) && this.answeredQuestions.get(question) === answer
        && respQ.questionText === question.questionText
        && respQ.rightAnswer.answerText !== answer.answerText) {
        return true;
      }
    }
    return false;
  }

  isSelected(question, answer) {
    if (this.answeredQuestions.has(question)) {
      return this.answeredQuestions.get(question) === answer;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/operating-standard/user-familiarize-standard/testing-action/testing-action.component.ts